import axios from "axios";
import { sessionizeUrl } from "../main";
import atlasAPI from '../services/atlasAPI'


export const counterUpdate = (context, payload) => {
    context.commit("setCount", payload.count);
}

export const getSessions = ({ state, dispatch, commit }) => {
    axios
        .get(sessionizeUrl + "Sessions")
        .then((response) => {
            commit("SET_SESSIONS", response.data[0].sessions);
        })
        .catch((error) => {
            console.error(error);
        });
}

export const getSpeakers = ({ state, dispatch, commit }) => {
    axios
        .get(sessionizeUrl + "Speakers")
        .then((response) => {
            commit("SET_SPEAKERS", response.data);
        })
        .catch((error) => {
            console.error(error);
        });
}

export const getScheduleGrid = ({ state, dispatch, commit }) => {
    axios
        .get(sessionizeUrl + "GridSmart")
        .then((response) => {
            commit("SET_SCHEDULE_GRID", response.data);
        })
        .catch((error) => {
            console.error(error);
        });
}

export const filterOldSchedules = async (context) => {
    const myscheduleid = localStorage.getItem('myscheduleid')
    const revertmyschedule = localStorage.getItem('revertmyschedule')

    // Remove cached scheduleId if it does not exist in mongo
    if (myscheduleid) {
        try {
            const response = await atlasAPI.get("getSchedule?id=" + myscheduleid);
            if (!response || !response.data || !response.data._id) {
                localStorage.setItem('myscheduleid', "")
            } else {
                // Set cached schedule from mongo
                const schedule = response.data.sessions;
                localStorage.setItem("schedule", JSON.stringify(schedule));
                context.commit("setCount", schedule.length);
            }
        } catch (error) {
            console.error(error);
        }
    }

    // Remove cached revertmyschedule if it does not exist in mongo
    if (revertmyschedule) {
        try {
            const response = await atlasAPI.get("getSchedule?id=" + revertmyschedule);
            if (!response || !response.data || !response.data._id) localStorage.setItem('revertmyschedule', "");
        } catch (error) {
            console.error(error);
        }
    }

    if (!localStorage.getItem("schedule") || localStorage.getItem("schedule") === "undefined" || localStorage.getItem("schedule") === "null") {
        localStorage.setItem("schedule", JSON.stringify([]))
    } else {
        // Filter old cached sessions
        const schedule = JSON.parse(localStorage.getItem("schedule"));
        axios
            .get(sessionizeUrl + "Sessions")
            .then((response) => {
                const allSessionIds = response.data[0].sessions.map(val => String(val.id));

                // Filter out IDs in locStoredSchedules that are not in allSessionIds
                const filteredSchedule = schedule.filter(sessionId => allSessionIds.includes(String(sessionId)));

                // Set filtered as local storage
                localStorage.setItem("schedule", JSON.stringify(filteredSchedule));

                context.commit("setCount", filteredSchedule.length);
            }).catch((error) => {
                console.error(error);
            })
    }
}



// WEBPACK FOOTER //
// ./src/store/actions.js